let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bngha")).then(() => parcelRequire('bO1y4'));